(() => {
  const mobile = matchMedia('(max-width: 749px)');
  const selectors = 'main variant-picker select, main select.variant-option__select';
  let active; const radioGroups = new WeakMap();
  // Display text of a radio choice: data-pf-label when the section provides one (ca. slipper sizes: "39 · US W 8 / M 6.5"), else its value.
  const radioText = radio => radio?.dataset.pfLabel || radio?.value || '';
  function labelFor(select) {
    return select.getAttribute('aria-label') || document.querySelector(`label[for="${CSS.escape(select.id)}"]`)?.textContent.trim() || select.closest('fieldset')?.querySelector('legend')?.textContent.trim() || select.name.replace(/^options\[|\]$/g, '');
  }
  function enhance() {
    document.querySelectorAll('main fieldset[data-option], main fieldset[data-option-index], main variant-picker fieldset.variant-option').forEach(field => {
      const radios = [...field.querySelectorAll('input[type="radio"]')];
      if (field.dataset.pfSheetReady || radios.length < 2) return;
      field.dataset.pfSheetReady = '1'; field.classList.add('pf-sheet-radio-group');
      const trigger = document.createElement('button'); trigger.type = 'button'; trigger.className = 'pf-sheet-trigger';
      trigger.setAttribute('aria-label', field.querySelector('legend')?.textContent.trim() || 'Auswahl'); trigger.setAttribute('aria-haspopup', 'dialog');
      const current = document.createElement('span'); current.textContent = radioText(radios.find(r => r.checked)); trigger.append(current); field.append(trigger);
      radioGroups.set(trigger, radios); field.addEventListener('change', () => { current.textContent = radioText(radios.find(r => r.checked)); });
    });
    document.querySelectorAll(selectors).forEach(select => {
      if (select.dataset.pfSheetReady) return;
      select.dataset.pfSheetReady = '1';
      select.classList.add('pf-sheet-native');
      const trigger = document.createElement('button');
      trigger.type = 'button'; trigger.className = 'pf-sheet-trigger';
      trigger.setAttribute('aria-label', labelFor(select)); trigger.setAttribute('aria-haspopup', 'dialog');
      const current = document.createElement('span'); current.textContent = select.selectedOptions[0]?.textContent || '';
      trigger.append(current); select.after(trigger);
      select.addEventListener('change', () => { current.textContent = select.selectedOptions[0]?.textContent || ''; });
    });
  }
  function open(select, trigger) {
    if (select.disabled) return;
    active?.close();
    const dialog = document.createElement('dialog'); dialog.className = 'pf-mobile-sheet'; if (trigger.closest('main[data-template="product.winter-heated-socks"]')) dialog.classList.add('pf-socks-sheet'); active = dialog;
    const head = document.createElement('header'), heading = document.createElement('h2'), close = document.createElement('button');
    heading.textContent = labelFor(select); heading.id = 'pf-mobile-sheet-title'; dialog.setAttribute('aria-labelledby', heading.id);
    close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', document.querySelector('[data-pf-sheet-close]')?.dataset.pfSheetClose || 'Schließen'); close.onclick = () => dialog.close();
    head.append(heading, close);
    const choices = document.createElement('div'); choices.className = 'pf-mobile-sheet-options';
    for (const option of select.options) {
      const button = document.createElement('button'); button.type = 'button'; button.textContent = option.textContent;
      button.disabled = option.disabled; button.setAttribute('aria-pressed', String(option.selected));
      button.onclick = () => {
        select.value = option.value;
        const current = trigger.querySelector('span'); if (current) current.textContent = option.textContent;
        dialog.close(); select.dispatchEvent(new Event('change', { bubbles: true }));
      }; choices.append(button);
    }
    dialog.append(head, choices); document.body.append(dialog);
    const priorOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
    dialog.addEventListener('close', () => { document.body.style.overflow = priorOverflow; dialog.remove(); if (active === dialog) active = null; if (trigger.isConnected) trigger.focus({preventScroll:true}); }, {once:true});
    dialog.addEventListener('click', event => { if (event.target === dialog && event.clientY < dialog.getBoundingClientRect().top) dialog.close(); });
    dialog.showModal(); choices.querySelector('[aria-pressed="true"]')?.focus({preventScroll:true});
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (!mobile.matches && !event.target.closest('main[data-template="product.winter-heated-socks"]')) return;
    const trigger = event.target.closest('.pf-option-trigger, .jnh-choice-trigger, .pf-sheet-trigger');
    if (!trigger || !trigger.closest('main')) return;
    let select = trigger.parentElement.querySelector('select');
    const radios = radioGroups.get(trigger);
    if (radios) {
      select = document.createElement('select'); select.setAttribute('aria-label', trigger.getAttribute('aria-label'));
      radios.forEach(radio => { const option = new Option(radioText(radio), radio.value, false, radio.checked); option.disabled = radio.disabled; select.append(option); });
      select.addEventListener('change', () => radios.find(radio => radio.value === select.value)?.click());
    }
    if (!select) return;
    event.preventDefault(); event.stopImmediatePropagation(); open(select, trigger);
  }, true);
  const observer = new MutationObserver(() => enhance());
  observer.observe(document.querySelector('main') || document.body, {childList:true,subtree:true});
  mobile.addEventListener('change', () => { if (!mobile.matches) active?.close(); });
  enhance();
})();
